import { render, staticRenderFns } from "./material2.vue?vue&type=template&id=355c4bae&scoped=true&"
import script from "./material2.vue?vue&type=script&lang=js&"
export * from "./material2.vue?vue&type=script&lang=js&"
import style0 from "./material2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./material2.vue?vue&type=style&index=1&id=355c4bae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c4bae",
  null
  
)

export default component.exports